<template>
	<div class="login_conter">
		<div>
			<div class="login_text">登录</div>
			<div class="login_name">您好，欢迎来到河北尚学教育！</div>
			<ul v-if="verificationCodeLogin">
				<li class="login_li">
					<input type="number" placeholder="请输入手机号" v-model="phone" />
				</li>
				<li class="login_li">
					<input maxlength="6" v-model="codes" type="number" placeholder="请输入验证码" />
					<div class="login_code" v-if="isCount" @click="codeSub">发送验证码</div>
					<div class="login_code" v-else>
						<van-count-down :time="time" format="ss" @finish="finish">
							<template #default="timeData">
								<span class="block">{{ timeData.seconds }}S</span>
							</template>
						</van-count-down>
					</div>
				</li>
			</ul>
			<ul v-else>
				<li class="login_li">
					<input v-model="account" placeholder="请输入账户" />
				</li>
				<li class="login_li">
					<input type="password" v-model="login_password" placeholder="请输入密码" />
				</li>
			</ul>
			<div class="login_btn" @click="getLogin">
					登录
			</div>
		</div>
		<div class="reg-div-con">
			<div class="reg-divs">
				<div @click="change">{{verificationCodeLogin ? '密码登录' : '验证码登录'}}</div>
			</div>
		</div>
	</div>
</template>
<script>

  import { sendCode, bindingPhone, passLogin } from '@/api/api'
	import store from "@/store";
	export default {
		data() {
			return {
				time: 300000,
				isCount: true,
				codes: '',
				phone: '',

				verificationCodeLogin:true,   // true 默认 短信登录
				account: '',//账户
				login_password: '',//密码

				//spread:'',//推荐人uid
			};
		},
		beforeRouteEnter(to, from, next) {
			
			if(store.state.token){ //如果有就直接到首页咯
				if(store.state.if_class && store.state.className){
					next('/index');
				} else {
					console.log(884448)
					next('/chooseexam');
				}
			} else {
				next();
			}
		},
		created() {
			//this.initUrl();
			console.log('sss',localStorage.getItem('spread'))
		},
		mounted(){
			//console.log('111--verificationCodeLogin',this.verificationCodeLogin)
		},
		methods: {
			// initUrl(){
			// 	let geturl = window.location.href 
			// 	let getqyinfo = geturl.split('?')[1]   //qycode=1001&qyname=%E4%BC%81%E4%B8%9A%E5%BF%99   截取到参数部分
			// 	let getqys = new URLSearchParams('?'+getqyinfo)  //将参数放在URLSearchParams函数中
			// 	let spread = getqys.get('spread')   //1001   
			// 	if(spread > 0){
			// 		this.spread = spread
			// 	}
			// 	console.log('推荐人1',spread)
			// },
			change() {
				this.verificationCodeLogin = !this.verificationCodeLogin
			},
			// 登陆
			// async getLogin(){
        	// 	if (!this.valitPhone() || !this.valitCode()) {
			// 		return
			// 	}
			// 	if(this.isCount){
          	// 		return this.$toast( "请获取正确验证码");
			// 	}
        	// 	const res = await bindingPhone({ phone: this.phone, code: this.codes })
			// 	if(res.code == 1000){
			// 		res.data.authorization && store.commit('setToken', res.data.authorization)
			// 		if(store.state.if_class && store.state.className){
            // 			this.$router.replace('/index')
			// 		} else {
            // 			this.$router.replace('/chooseexam')
			// 		}
			// 	} else {
			// 		this.$toast(res.msg)
			// 	}
			// }
			// 密码登陆
			async getLogin(){
				console.log('ss',this.spread)
				//return
				//console.log('verificationCodeLogin',this.verificationCodeLogin)
				if(this.verificationCodeLogin){
					if (!this.valitPhone() || !this.valitCode()) {
						return
					}
					if(this.isCount){
						return this.$toast( "请获取正确验证码");
					}

					//邀请人
					let spread = ''
					if(localStorage.getItem('spread')){
						spread = localStorage.getItem('spread')
					}
					console.log('推荐人2',spread)
					const res = await bindingPhone({ phone: this.phone, code: this.codes,spread:spread })

					//以下逻辑相同
					if(res.code == 1000){
						if(res.data.professional_classification_id > 0){
							//和选择专业那处理方式相同
							this.$store.commit('setClass', 1)
							this.$store.commit('setClassName', res.data.professional_classification_name)
							localStorage.setItem('merFlag', 1)
						}
						res.data.authorization && store.commit('setToken', res.data.authorization)
						if(store.state.if_class && store.state.className){
							this.$router.replace('/index')
						} else {
							this.$router.replace('/chooseexam')
						}
					} else {
						this.$toast(res.msg)
					}
				}else{
					if (!this.account || !this.login_password) {
						return this.$toast( "请输入账号密码");
					}
					//密码登陆无需绑定推荐人，因为肯定是后台添加的不存在推荐人
					const res = await passLogin({ account: this.account, login_password: this.login_password })

					//以下逻辑相同
					if(res.code == 1000){
						if(res.data.professional_classification_id > 0){
							//和选择专业那处理方式相同
							this.$store.commit('setClass', 1)
							this.$store.commit('setClassName', res.data.professional_classification_name)
							localStorage.setItem('merFlag', 1)
						}
						console.log('登陆成功了store',store.state)
						res.data.authorization && store.commit('setToken', res.data.authorization)
						if(store.state.if_class && store.state.className){
							this.$router.replace('/index')
						} else {
							this.$router.replace('/chooseexam')
						}
					} else {
						this.$toast(res.msg)
					}
				}
				
			},

			// 验证手机号
		 	valitPhone(){
				const test = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
        		if (!(test.test(this.phone))) {
					this.$toast( "请正确输入手机号");
					return false;
				} else {
					return true;
				}
			},

			// 验证验证码
			valitCode(){
        		const test = /^\d{6}$/
				if (!(test.test(this.codes))) {
					this.$toast( "请正确输入验证码");
					return false;
				} else {
					return true;
				}
			},

			async codeSub() {
				
				if(!this.valitPhone()){
          			return
				}
				const res = await sendCode({ phone: this.phone })
				if(res.code == 1000){
					this.isCount = false
				} else {
					this.$toast(res.msg)
				}
				
			},
			finish() {
				this.isCount = true
			},
      
			
		}
	};
</script>
<style lang="less">
	.login_conter {
		padding: 50px 30px;
    box-sizing: border-box;

		.login_text {
			font-size: 27px;
			font-weight: 600;
			color: #333333;
		}

		.login_name {
			font-size: 18px;
			font-weight: 500;
			color: #9999AB;
			margin-top: 20px;
		}

		.login_li {
			height: 40px;
			.flexs();
			margin-top: 20px;
			border-bottom: 1px solid #E8E8E8;
		}

		input {
			flex: 1;
			height: 100%;
			font-size:16px;
		}

		.login_code {
			width: 100px;
			line-height: 40px;
			color: @theme-color;
			font-size: 14px;
			text-align: right;

			.block {
				color: @theme-color;
			}
		}
	}
	
	.reg-div-con{
		width: 100%;
		text-align: center;
		margin-top:20px;
		color: #497CFF;
	}
</style>
